export default (function (arr) { return arr[arr.length - 1]; });
